import { Car } from "@phosphor-icons/react";
import type { FeaturePalette } from "@/shared/components/command-palette/types";

export const drivingPalette: FeaturePalette = {
  commands: [
    {
      id: "driving.open",
      title: "Open driving",
      icon: Car,
      scopeId: "driving",
      keywords: ["drives", "car", "trips", "commute"],
      run: (ctx) => ctx.router.push("/driving"),
    },
  ],
};
